<div *ngIf="usefulLinkPay" class="govuk-grid-row" data-testid="usefulLinkPayTestId">
  <div class="govuk-width-container govuk-!-padding-4">
    <h2 class="govuk-heading-m govuk-!-margin-top-7">
      {{ usefulLinkPay.title }}
    </h2>
    <div class="asc-cms-content" [innerHTML]="usefulLinkPay.content"></div>
  </div>
</div>
